import { Box, Typography, useTheme } from "@mui/material";
import { type FC, useState } from "react";
import { ExpandToggleButton } from "web_myplann/Shared/Components/ExpandToggleButton";
import { TASK_DESCRIPTION_PREVIEW_LIMIT } from "web_myplann/Tasks/constants";

type Props = {
	label: string;
	text: string;
};

export const TaskDescription: FC<Props> = ({ label, text }) => {
	const theme = useTheme();
	const [expanded, setExpanded] = useState(false);

	const isLong = text.length > TASK_DESCRIPTION_PREVIEW_LIMIT;
	const preview = isLong
		? `${text.slice(0, TASK_DESCRIPTION_PREVIEW_LIMIT)}...`
		: text;

	return (
		<Box>
			<Box
				px={1.6}
				pt={1.2}
				pb={0.4}
				borderTop={1}
				borderColor="surface.border"
			>
				<Typography variant="overline" color="text.disabled">
					{label}
				</Typography>
			</Box>
			<Box px={1.6} pb={1.2}>
				<Typography
					variant="body1"
					color={theme.palette.grey[700]}
					lineHeight={theme.lineHeight.relaxed}
				>
					{expanded ? text : preview}
				</Typography>
				{isLong && (
					<ExpandToggleButton
						isExpanded={expanded}
						onClick={() => setExpanded((value) => !value)}
						fontSize={12}
					/>
				)}
			</Box>
		</Box>
	);
};
